import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (email, senha) => api.post('/auth/login', { email, senha });
export const register = (nome, email, senha) => api.post('/auth/register', { nome, email, senha });
export const googleLogin = (token) => api.post('/auth/google', { token });
export const getPerfil = () => api.get('/auth/perfil');
export const updatePerfil = (data) => api.put('/auth/perfil', data);
export const completeOnboarding = () => api.post('/auth/complete-onboarding');

// Contas
export const getContas = () => api.get('/contas');
export const getConta = (id) => api.get(`/contas/${id}`);
export const createConta = (data) => api.post('/contas', data);
export const updateConta = (id, data) => api.put(`/contas/${id}`, data);
export const deleteConta = (id) => api.delete(`/contas/${id}`);

// Lançamentos
export const getLancamentos = () => api.get('/lancamentos');
export const getLancamento = (id) => api.get(`/lancamentos/${id}`);
export const createLancamento = (data) => api.post('/lancamentos', data);
export const updateLancamento = (id, data) => api.put(`/lancamentos/${id}`, data);
export const deleteLancamento = (id) => api.delete(`/lancamentos/${id}`);
export const deleteAllLancamentos = () => api.delete('/lancamentos/all');
export const togglePagoLancamento = (id) => api.patch(`/lancamentos/${id}/toggle-pago`);
export const getDashboard = () => api.get('/lancamentos/dashboard');
export const analyzeInvoice = (formData) => api.post('/lancamentos/analyze-invoice', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const confirmInvoiceImport = (data) => api.post('/lancamentos/confirm-import', data);

// Logs
export const getLogs = () => api.get('/logs');
export const getLogsEnvios = (params) => api.get('/logs/envios', { params });

// Categorias
export const getCategorias = () => api.get('/categorias');
export const createCategoria = (data) => api.post('/categorias', data);
export const updateCategoria = (id, data) => api.put(`/categorias/${id}`, data);
export const deleteCategoria = (id) => api.delete(`/categorias/${id}`);
export const getSubcategorias = (categoriaId) => api.get(`/categorias/${categoriaId}/subcategorias`);
export const createSubcategoria = (categoriaId, data) => api.post(`/categorias/${categoriaId}/subcategorias`, data);
export const updateSubcategoria = (id, data) => api.put(`/categorias/subcategorias/${id}`, data);
export const deleteSubcategoria = (id) => api.delete(`/categorias/subcategorias/${id}`);
export const saveLimiteCategoria = (id, valor_limite) => api.post(`/categorias/${id}/limite`, { valor_limite });
export const saveLimiteSubcategoria = (id, valor_limite) => api.post(`/categorias/subcategorias/${id}/limite`, { valor_limite });
export const getMediaGastoCategoria = (id) => api.get(`/categorias/${id}/media`);
export const getMediaGastoSubcategoria = (id) => api.get(`/categorias/subcategorias/${id}/media`);

// WhatsApp / Evolution
export const getWhatsappStatus = () => api.get('/whatsapp/status');
export const getEvolutionConfig = () => api.get('/whatsapp/config');
export const updateEvolutionConfig = (data) => api.post('/whatsapp/config', data);
export const sendTestMessage = (whatsapp) => api.post('/whatsapp/test-message', { whatsapp });
export const sendRemindersNow = () => api.post('/whatsapp/send-reminders-now');

// Email / SMTP
export const getSmtpConfig = () => api.get('/email/config');
export const updateSmtpConfig = (data) => api.post('/email/config', data);
export const sendTestEmail = (to) => api.post('/email/test-email', { to });
export const getEmailTemplates = () => api.get('/email/templates');
export const updateEmailTemplate = (slug, data) => api.put(`/email/templates/${slug}`, data);

// Entradas Projetivas
export const getEntradasProjetivas = () => api.get('/entradas-projetivas');
export const createEntradaProjetiva = (data) => api.post('/entradas-projetivas', data);
export const createEntradasProjetivasBulk = (data) => api.post('/entradas-projetivas/bulk', data);
export const updateEntradaProjetiva = (id, data) => api.put(`/entradas-projetivas/${id}`, data);
export const deleteEntradaProjetiva = (id) => api.delete(`/entradas-projetivas/${id}`);


// Admin
export const adminGetUsers = (search = '') => api.get(`/admin/users${search ? `?search=${search}` : ''}`);
export const adminResetPassword = (id, novaSenha) => api.post(`/admin/users/${id}/reset-password`, { novaSenha });
export const adminToggleAdmin = (id, isAdmin) => api.patch(`/admin/users/${id}/toggle-admin`, { isAdmin });
export const adminTogglePro = (id, isPro) => api.patch(`/admin/users/${id}/toggle-pro`, { isPro });
export const adminDeleteUser = (id) => api.delete(`/admin/users/${id}`);
export const adminGetUserPayments = (id) => api.get(`/admin/users/${id}/payments`);
export const adminGetConfigs = () => api.get('/admin/configs');
export const adminUpdateConfig = (chave, valor) => api.post('/admin/configs', { chave, valor });
export const adminSendEmailBatch = (userIds, templateSlug) => api.post('/admin/users/send-email-batch', { userIds, templateSlug });

// Subscription
export const generatePixSubscription = () => api.post('/subscription/generate-pix');
export const checkSubscriptionStatus = (txid) => api.get(`/subscription/status/${txid}`);
export const getSubscriptionHistory = () => api.get('/subscription/history');
export const getPublicSubscriptionConfig = () => api.get('/subscription/config');

// Lembretes
export const getLembretes = () => api.get('/lembretes');
export const createLembrete = (data) => api.post('/lembretes', data);
export const updateLembrete = (id, data) => api.put(`/lembretes/${id}`, data);
export const deleteLembrete = (id) => api.delete(`/lembretes/${id}`);

export default api;
